module.exports = __webpack_public_path__ + "safari-pinned-tab-523fadd741a0590651b98acc4349bc14.svg";